import { Component, Input, OnInit } from '@angular/core';
import { AnimationOptions, LottieComponent } from 'ngx-lottie';

@Component({
  selector: 'app-loader',
  standalone: true,
  imports: [LottieComponent],
  templateUrl: './loader.html',
  styleUrl: './loader.scss',
})
export class Loader implements OnInit {
  @Input() isDelayed = false;
  @Input() delayMs = 1000;
  showLoader = false;

  options: AnimationOptions = {
    path: '/lottie/loader.json',
    autoplay: true,
    loop: true,
  };

  ngOnInit() {
    if (this.isDelayed) {
      setTimeout(() => {
        this.showLoader = true;
      }, this.delayMs);
    } else {
      this.showLoader = true;
    }
  }
}
